var antPrefixCls = '.ant-table';
var genTableStyle = function genTableStyle(token) {
  var _ref, _ref2, _ref3;
  return _ref3 = {}, _ref3[antPrefixCls + "-wrapper"] = (_ref2 = {
    '.ant-table': {
      'scrollbar-color': token.colorFill + " transparent"

      // '&::-webkit-scrollbar': {
      //   color: 'red',
      //   backgroundColor: 'red'
      // },
    }
  }, _ref2[antPrefixCls + "-tbody > tr > td"] = {
    a: {
      color: token.tableCellActionColor
    },
    '.ant-dropdown-trigger': {
      letterSpacing: '2px',
      fontSize: 18
    }
  }, _ref2[antPrefixCls + "-tbody > tr"] = (_ref = {}, _ref["&" + antPrefixCls + "-row-selected"] = {
    '&:hover > td': {
      background: 'initial'
    }
  }, _ref), _ref2[antPrefixCls + "-thead tr"] = {
    'th::before': {
      content: 'unset',
      display: 'none'
    }
  }, _ref2[antPrefixCls + "-thead >tr>th"] = {
    fontWeight: token.fontWeightMedium
  }, _ref2['table tr td.ant-table-selection-column,table tr th.ant-table-selection-column'] = {
    'padding-inline-start': '24px'
  }, _ref2['.ant-table-pagination.ant-pagination'] = {
    margin: '16px 0'
  }, _ref2), _ref3;
};
var tableStyleFn = function tableStyleFn(token) {
  return [genTableStyle(token)];
};

export { tableStyleFn };
